export default __webpack_public_path__ + "34bb20184fe9ad4d227df06f84a43bed.png";